var path = 'app/scripts/modules/core/src/whatsNew/whatsNew.directive.html';
var html = "<li class=\"whats-new\" ng-if=\"fileLastUpdated\">\n  <a href class=\"remove-border-top\" ng-click=\"showWhatsNew()\" ng-class=\"{unread: updatesUnread()}\">\n    <span class=\"glyphicon glyphicon-info-sign\"></span>\n    <span class=\"hidden-xs hidden-sm hidden-md\">What's New</span>\n  </a>\n</li>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/whatsNew/whatsNew.directive.html
// module id = 1086
// module chunks = 0